/*
 * Copyright (C) 2018 - 2023 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from 'react';
import { message, Row, Col, Popconfirm, Divider } from 'antd';
import { Modal, Input } from 'antd';
import { EditOutlined, DeleteOutlined, CopyOutlined } from '@ant-design/icons';
import { withTranslation } from 'react-i18next';

class File extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      rename: this.props.title,
      copy: false,
    };
  }

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    const { t } = this.props;
    if (this.state.rename === '' || this.state.rename === null) {
      message.info(t('correctName_infoTxt'));
    } else {
      this.setState(
        {
          visible: false,
        },
        () => {
          this.props.onSelectOperation(
            'Rename',
            this.props.filePath,
            this.state.rename,
          );
          this.setState({
            rename: '',
          });
        },
      );
    }
  };

  handleCancel = e => {
    this.setState({
      visible: false,
    });
  };

  updateEventValue = evt => {
    this.setState({
      rename: evt.target.value,
    });
  };

  confirm = e => {
    this.props.saveLocalFilePath(this.props.filePath);
  };

  cancel = e => {
    const { t } = this.props;
    message.error(t('cancelCopyProcess_Txt'));
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        {this.props.serverFileCopied && this.props.type === 'Folder' ? (
          <Popconfirm
            title={t('copyFile_confirmTxt')}
            onConfirm={this.confirm}
            onCancel={this.cancel}
            okText={t('label_yes')}
            cancelText={t('label_no')}
          >
            <Row>
              <Col span={8}>{this.props.title}</Col>
              <Col span={4}>{this.props.size}</Col>
              <Col span={6}>{this.props.lastModified}</Col>
              <Col span={6}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '80%',
                  }}
                >
                  <Popconfirm
                    title={t('deleteFile_confirmTxt')}
                    onConfirm={() => {
                      this.props.onSelectOperation(
                        'Delete',
                        this.props.filePath,
                      );
                    }}
                    onCancel={() => {
                      message.info(t('cancelDeleteProcess_Txt'));
                    }}
                    okText={t('label_yes')}
                    cancelText={t('label_no')}
                  >
                    <DeleteOutlined />
                  </Popconfirm>
                  <EditOutlined onClick={this.showModal} />
                </div>
              </Col>
            </Row>
            <Divider />
          </Popconfirm>
        ) : (
          <>
            <Row onClick={this.printFilePath}>
              <Col span={8}>{this.props.title}</Col>
              <Col span={4}>{this.props.size}</Col>
              <Col span={6}>{this.props.lastModified}</Col>
              <Col span={6}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '80%',
                  }}
                >
                  <Popconfirm
                    title={t('deleteFile_confirmTxt')}
                    onConfirm={() => {
                      this.props.onSelectOperation(
                        'Delete',
                        this.props.filePath,
                      );
                    }}
                    onCancel={() => {
                      message.info(t('cancelDeleteProcess_Txt'));
                    }}
                    okText={t('label_yes')}
                    cancelText={t('label_no')}
                  >
                    <DeleteOutlined />
                  </Popconfirm>
                  {this.props.login && this.props.type === 'File' ? (
                    <CopyOutlined
                      onClick={() => {
                        this.props.onSelectOperation(
                          'Transfer File',
                          this.props.filePath,
                        );
                      }}
                    />
                  ) : null}
                  <EditOutlined onClick={this.showModal} />
                </div>
              </Col>
            </Row>
            <Divider />
          </>
        )}
        <Modal
          title={t('label_rename')}
          open={this.state.visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Input
            placeholder={t('label_rename')}
            value={this.state.rename}
            onChange={evt => this.updateEventValue(evt)}
          />
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(File);
